import { isFeatureActive } from '@helpers';
import { BOOZTLET_COOKIE_CONSENT_FEATURE, BOOZT_COOKIE_CONSENT_FEATURE } from '@common/CS/components/CookiePolicy/constants';
import { useConfig } from '@common/Hooks/useConfig';
import './CookiePolicyTrigger.scss';

function CookiePolicyTrigger({ label, cssClass }) {
    const config = useConfig();

    const handleShowCookieBanner = () => {
        // Display onetrust cookie consent banner
        const { OneTrust } = window;

        if (!OneTrust) {
            throw new Error('OneTrust lib is not defined, cannot display banner');
        }

        OneTrust.ToggleInfoDisplay();
    };

    const handleClick = () => {
        if (isFeatureActive(BOOZT_COOKIE_CONSENT_FEATURE, config) || isFeatureActive(BOOZTLET_COOKIE_CONSENT_FEATURE, config)) {
            handleShowCookieBanner();
        }
    };

    return (
        <button
            className={cssClass}
            type="button"
            onClick={handleClick}
        >
            {label}
        </button>
    );
}

export default CookiePolicyTrigger;
